module.exports = __webpack_public_path__ + "img/Nagad.002ddf5a.png";